import React from 'react';
import IconButton from '@mui/material/IconButton';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import BotaoVoltar from "./common/botaoVoltar";
import DistVafCircularProgress from "./common/distVafCircularProgress";
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import $ from 'jquery'
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import {URL_API} from '../config/urls'
import fetchWithToken from '../config/UseFetchWithToken';

class Download extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			ano: "",
			arquivos: [],
			dadosAf: [],
			dadosPrefeitura: [],
			dadosSrf: [],
			nomeArquivo: "",
			numeroRetorno: "",
			qualTab: "2",
			tipoArquivo: "",
			loader: false
		}
		this.baixarArquivo = this.baixarArquivo.bind(this);
		this.controlarItem = this.controlarItem.bind(this);
		this.controlarSelecaoNomeArquivo = this.controlarSelecaoNomeArquivo.bind(this);
		this.controlarTabs = this.controlarTabs.bind(this);
	}

	componentDidMount() {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}
		
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': `Bearer ${token_keycloack}` },
			body: "pasta=VAFRET/ATIVOS_E_RETORNOS" +
				"&filtro=*"
		};
		fetchWithToken(`${URL_API}/api/v1/ftp/listarArquivos`, requestOptions)
			.then(res => res.json())
			.then(res => {
				if(res !== null && res !== ""){
					this.setState({ arquivos: res })
					this.definirVariaveis(res[0])
				}
				
			})
			.catch(_err => {
				alert("Ocorreu um erro: "+_err);
				console.error("Ocorreu um erro - " + _err)
			})
		fetchWithToken(`${URL_API}/api/v1/af/obterAf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ dadosAf: res })
					let itensAf = [];
					res.map((_item) => (
						itensAf[_item.codigo] = false
					))
					this.setState({ marcadosAf: itensAf })
				}
			})
			.catch(_err => {
				console.error("Erro interno na aplicação.")
			});
		fetchWithToken(`${URL_API}/api/v1/prefeitura/obterPrefeitura`,requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível!")
				}
				else {
					this.setState({ dadosPrefeitura: res })
					let itensPrefeitura = [];
					res.map((_item) => (
						itensPrefeitura[_item.codigo] = false
					))
					this.setState({ marcadosPrefeitura: itensPrefeitura })
					$(document).ready(function () {
						setTimeout(function () {
							$('#tblAf').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 },
									{ orderable: false, targets: 1 }
								],
								language: {
									url: '/pt-BR.json'
								}
							});
							$('#tblPrefeitura').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 },
									{ orderable: false, targets: 1 }
								],
								language: {
									url: '/pt-BR.json'
								}
							});
							$('#tblSrf').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 },
									{ orderable: false, targets: 1 }
								],
								language: {
									url: '/pt-BR.json'
								}
							});
						}, 100);
					});
				}
			})
			.catch(_err => {
				console.error("Erro interno na aplicação.")
			});
		fetchWithToken(`${URL_API}/api/v1/srf/obterSrf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ dadosSrf: res })
					let itensSrf = [];
					res.map((_item) => (
						itensSrf[_item.codigo] = false
					))
					this.setState({ marcadosSrf: itensSrf })
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
	}

	baixarArquivo(tipo, codigo) {
		let metodo = 'POST'
		let url = `${URL_API}/api/v1/arquivo/downloadArquivo`
		let dados = "nomeArquivo=" + this.state.nomeArquivo + "&tipo=" + tipo + "&codigo=" + codigo
		let token_keycloack = sessionStorage.getItem('token_keycloack');

		this.setState({ loader: true })
		const opcoes = {
			method: metodo,
			headers: {
				"Content-Type": "application/json",
				"Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
				"Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
				"Authorization": `Bearer ${token_keycloack}`
			},
			body: JSON.stringify({dados: dados})
		};
		fetch(url, opcoes)
			.then(res => res.blob())
			.then(blob => {
				const href = window.URL.createObjectURL(new Blob([blob]))
				const link = document.createElement('a')
				let nomeArquivo = ""
				let numeroRetorno = "01"
				let ano = ""
				let tipoArquivo = ""
				numeroRetorno = this.state.nomeArquivo.substring(this.state.nomeArquivo.lastIndexOf("_")+1, this.state.nomeArquivo.indexOf(".TXT"));

				if (this.state.nomeArquivo.substring(0, 5) === "ATIVO") {
					tipoArquivo = "A"
					ano = this.state.nomeArquivo.substring(18, 20);
				}
				else {
					tipoArquivo = "R"
					ano = this.state.nomeArquivo.substring(20, 22);
				}

				ano = parseInt(ano) + 1;

				if (tipo === "A") {
					nomeArquivo = "P"
				}
				else {
					if (tipo === "P") {
						nomeArquivo = "I"
					}
					else {
						nomeArquivo = "Z"
					}
				}
				nomeArquivo = nomeArquivo + codigo + tipoArquivo + "T" + numeroRetorno + ano + ".zip"
				link.href = href
				link.setAttribute('download', nomeArquivo)
				this.setState({ loader: false })
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
				
				alert("Download concluído!")
			})
			.catch(_err => {
				this.setState({ loader: false })
				alert("O arquivo não está disponível para download")
				console.error("Erro interno na aplicação - " + _err)
			});
	}

	classifica(a, b) {
		if (a.nome > b.nome) { return 1; }
		if (a.nome < b.nome) { return -1; }
		return 0;
	}

	controlarItem = (e) => {
		this.setState({ [e.target.id]: e.target.value });
	}

	controlarSelecaoNomeArquivo(e) {
		let valor = e.target.value
		console.log("value: %s", valor)
		this.setState({ nomeArquivo: valor })
	}

	controlarTabs(_e, qual) {
		this.setState({ qualTab: qual })
		setTimeout(function () {
			$('#tblAf').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],
				language: {
					url: '/pt-BR.json'
				}
			});
			$('#tblPrefeitura').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],
				language: {
					url: '/pt-BR.json'
				}
			});
			$('#tblSrf').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],
				language: {
					url: '/pt-BR.json'
				}
			});
		}, 1000);
	}

	definirVariaveis(valor) {
		let numeroRetorno = '01'
		this.setState({ nomeArquivo: valor })
		if (valor.substr(0, 5) === "ATIVO") {
			this.setState({ ano: valor.substr(16, 4) })
			if (valor.includes("_EM_")) {
				numeroRetorno = valor.substr(33, 2)
			}
		}
		else {
			this.setState({ ano: valor.substr(18, 4) })
			if (valor.includes("_EM_")) {
				numeroRetorno = valor.substr(35, 2)
			}
		}
		this.setState({ numeroRetorno: numeroRetorno })
		this.setState({ tipoArquivo: valor.substr(0, 1) })
	}

	render() {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<header className="main">
							<h2>DISTVAF - Download de Arquivos</h2>
						</header>
					</div>
				</div>
				<div className="row">
					<div className="col-6">
					</div>
					<div className="col-6">
						<BotaoVoltar />
					</div>
				</div>
				<form>
					<div className="row">
						<div className="col-12">
							<Paper variant="outlined">
								<div className="cabecalho">
									Arquivo para importação
								</div>
								<label>Selecione o arquivo</label>
								<select name="nomeArquivo" id="cmbNomeArquivo" onChange={this.controlarSelecaoNomeArquivo}>
									{this.state.arquivos != null && this.state.arquivos.map((result, index) => {
										return (
											<option key={result} value={result}>{result}</option>
										);
									})}
								</select>
							</Paper>
						</div>
					</div>
					{(this.state.loader && <DistVafCircularProgress />)}
					<div className="row">
						<div className="col-12">
							<Paper variant="outlined">
								<div className="cabecalho">
									Arquivos para download
								</div>
								<TabContext value={this.state.qualTab}>
									<TabList onChange={this.controlarTabs}>
										<Tab label="Prefeitura" value="2" />
										<Tab label="AF" value="1" />										
										<Tab label="SRF" value="3" />
									</TabList>
									<TabPanel value="1">
										<div className="table-wrapper ">
											<table id="tblAf" className="stripe row-border">
												<thead>
													<tr>
														<th>AF</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{this.state.dadosAf.sort(this.classifica).map((reg) => {
														return (
															<tr key={"af_" + reg.codigo}>
																<td>{reg.nome}</td>
																<td className='align-center'><IconButton className="pad0" color="primary" onClick={() => this.baixarArquivo("A", reg.codigo)}><FileDownloadIcon /></IconButton></td>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
									<TabPanel value="2">
										<div className="table-wrapper ">
											<table id="tblPrefeitura" className="stripe row-border">
												<thead>
													<tr>
														<th>Município</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{this.state.dadosPrefeitura.sort(this.classifica).map((reg) => {
														return (
															<tr key={"pr_" + reg.codigo}>
																<td>{reg.nome}</td>
																<td className='align-center'><IconButton className="pad0" color="primary" onClick={() => this.baixarArquivo("P", reg.codigo)}><FileDownloadIcon /></IconButton></td>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
									<TabPanel value="3">
										<div className="table-wrapper ">
											<table id="tblSrf" className="stripe row-border">
												<thead>
													<tr>
														<th>SRF</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													{this.state.dadosSrf.sort(this.classifica).map((reg) => {
														return (
															<tr key={"sr_" + reg.codigo}>
																<td>{reg.nome}</td>
																<td className='align-center'><IconButton className="pad0" color="primary" onClick={() => this.baixarArquivo("S", reg.codigo)}><FileDownloadIcon /></IconButton></td>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
								</TabContext>
							</Paper>
						</div>
					</div>
				</form>
				
			</div >
		)
	}
}

export default Download
